import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseComponent } from '../../../base.component';
import { MasarCriterionsService } from '../../../services/masar-criterions.service';

@Component({
	selector: 'app-add-edit-mistake',
	templateUrl: './add-edit-mistake.dialog.html',
	styleUrls: ['./add-edit-mistake.dialog.scss'],
})
export class AddEditMistakeComponent extends BaseComponent {
	form: FormGroup;
	criterions$ = this.masarCriterionsService.getMainCriterionByVisitKey(this.data.visitKey);

	criterionKey = 'criterion';
	mistakeLevels = [
		// { key: 'executiveSummary', label: 'forms.common.Criteria.executiveSummary' },
		{ key: this.criterionKey, label: 'forms.common.Criteria.Criterion' },
	];

	constructor(
		public dialogRef: MatDialogRef<AddEditMistakeComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private fb: FormBuilder,
		private datePipe: DatePipe,
		private masarCriterionsService: MasarCriterionsService
	) {
		super();
		this.initForm();
	}

	save() {
		const data = this.form.value;
		data.mistakeLevel = this.criterionKey;
		this.dialogRef.close(data);
	}

	cancel(): void {
		this.dialogRef.close();
	}

	changeMistakeLevel() {
		// const criterionControlKey = 'criterionKey';
		// if (this.form.value.mistakeLevel == this.criterionKey) {
		// 	this.form.get(criterionControlKey).setValidators([Validators.required]);
		// } else {
		// 	this.form.get(criterionControlKey).setValue(null);
		// 	this.form.get(criterionControlKey).clearValidators();
		// }
		// this.form.get(criterionControlKey).updateValueAndValidity();
	}

	private initForm() {
		this.form = this.fb.group({
			id: [this.data.model.id || null],
			mistakeLevel: [
				{ value: this.data.model.mistakeLevel || this.criterionKey, disabled: true },
				[Validators.required],
			],
			criterionKey: [
				{ value: this.data.model.criterionKey || '', disabled: this.data.viewOnly },
				[Validators.required],
			],
			mistake: [
				{ value: this.data.model.mistake || '', disabled: this.data.viewOnly },
				[Validators.required],
			],
			suggestedSolution: [
				{ value: this.data.model.suggestedSolution || '', disabled: this.data.viewOnly },
				[Validators.required],
			],
		});
	}
}
